<template>
    <div class="all">
      <Head></Head>
      <div class="jiejue">
        <div class="jiejue_top">
          <img src="../assets/topimg.jpg" alt="">
        </div>
      </div>
      <div class="jiejue1">
        <div class="jiejue_shop">
          <div class="jiejue_shop_for">
            <img src="../assets/zongjinglishi.png" alt="">
          </div>
          <div class="jiejue_shop_for">
            <img src="../assets/caiwushiyongpin.png" alt="" @click="getcaiwu">
          </div>
          <div class="jiejue_shop_for">
            <img src="../assets/bangongshiyongpin.png" alt="">
          </div>
          <div class="jiejue_shop_for">
            <img src="../assets/peixunshiyongpin.png" alt="" @click="getzhanhui">
          </div>
          <div class="jiejue_shop_for">
            <img src="../assets/huiyishiyongpin.png" alt="" @click="gethui">
          </div>
          <div class="jiejue_shop_for">
            <img src="../assets/houqinbu.png" alt="">
          </div>
          <div class="jiejue_shop_for">
            <img src="../assets/chashuijianyongpin.png" alt="" @click="getcha">
          </div>
          <div class="jiejue_shop_for">
            <img src="../assets/xishoujianyongpin.png" alt="" @click="getxishoujian">
          </div>
          <div class="jiejue_shop_for">
            <img src="../assets/zhuangdingdangan.png" alt="" @click="getzhuang">
          </div>
          <div class="jiejue_shop_for">
            <img src="../assets/wuliubaozhuang.png" alt="">
          </div>
          <div class="jiejue_shop_for" @click="$router.push({path:'/tesegou1'})">
            <img src="../assets/dingzhibangongyongpin.png" alt="">
          </div>
          <div class="jiejue_shop_for" @click="$router.push({path:'/tesegou2'})">
            <img src="../assets/dingzhiyinshua.png" alt="">
          </div>
          <div class="clear"></div>
        </div>
      </div>
      <div class="all_link">
        <div class="all_link_cen">
          <div class="all_link_cen_for" v-for="(item,key) in allbottom" :key="key">
            <div>{{ item.name }}</div>
            <ul>
              <li v-for="(value,key) in item.bottom_two" @click="getCliak(value.url)">{{value.name}}</li>
            </ul>
          </div>
        </div>
      </div>
      <Pagetail></Pagetail>
    </div>
  <!--
     <div class="jiejue_shop_for_bg">
              <p>文 字</p>
            </div>
            -->
</template>

<script>
  import Pagetail from '../assembly/Pagetail'
  import Head from '../assembly/Head'
  import {getinit} from "../api";
    export default {
        name: "jiejue",
      components:{
        Pagetail,Head
      },
      data(){
          return{
            allbottom:[]
          }
      },
      mounted() {
          this.init()
      },
      methods:{
        getCliak(url){
          // console.log(url)
          window.open(url)
        },
        getcaiwu(){
          // console.log(url)
          window.open('http://bgsxqy.com/#/tesegou?id=461,1281')
        },
        getzhuang(){
          // console.log(url)
          window.open('http://bgsxqy.com/#/tesegou?id=462,1101')
        },
        getcha(){
          // console.log(url)
          window.open('http://bgsxqy.com/#/tesegou?id=713,714,711,1190')
        },
        getzhanhui(){
          // console.log(url)
          window.open('http://bgsxqy.com/#/tesegou?id=174,459,691')
        },
        getxishoujian(){
          // console.log(url)
          window.open('http://bgsxqy.com/#/tesegou?id=696,710,937')
        },
        gethui(){
          // console.log(url)
          window.open('http://bgsxqy.com/#/ListOfCommodities?name=%E4%BC%9A%E8%AE%AE')
        },
        init() {
          getinit().then(res => {
            this.allbottom = res.bottom;
          });
        },
      }
    }
</script>

<style scoped lang="less">
  @import "css/jiejue";
</style>



// WEBPACK FOOTER //
// src/components/jiejue.vue